var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssistantIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5203_11381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.52057 17.6613L19.6869 11.6886V5.69922H15.5066L8.52057 11.6886V17.6613Z",
    fill: "#FD8F01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6901 5.50757H23.5293L19.219 1.19727L15.3436 5.0727L15.6901 5.50757Z",
    fill: "#FDCB50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.52058 11.6882L8.20895 19.8941L0.470459 23.0623L7.87686 11.4805L8.52058 11.6882Z",
    fill: "#FDCB50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2715 11.6883H8.20902L1.19763 0.9375H12.1562L19.5051 11.4287L19.2715 11.6883Z",
    fill: "#FDCB50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3325 11.6886H8.20874L1.19745 0.9375H10.0454C9.07557 2.26503 8.5071 3.87726 8.5071 5.61515C8.5071 8.02127 9.59651 10.186 11.3325 11.6886Z",
    fill: "#FD8F01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.52045 17.6613L19.6868 11.6886V5.69922",
    stroke: "#052A75",
    strokeWidth: 0.941176,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.52045 11.6882L8.20883 19.8941L0.470337 23.0623L7.87674 11.4805",
    stroke: "#052A75",
    strokeWidth: 0.941176,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6899 5.50757H23.5291L19.2189 1.19727L15.3434 5.0727",
    stroke: "#052A75",
    strokeWidth: 0.941176,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2713 11.6883H8.20884L1.19745 0.9375H12.156L19.5049 11.4287",
    stroke: "#052A75",
    strokeWidth: 0.941176,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5203_11381"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssistantIcon4);
export default __webpack_public_path__ + "static/media/assistant-icon-4.8cd17b82c1a83755e746061732e49a3c.svg";
export { ForwardRef as ReactComponent };